import React from "react";
import H from "next/head";

/**
 * Head component for title.
 * @param {Object} props
 */
const Head = ({ title = "Saweria", description, children }) => {
  const hostname = "Saweria";

  return (
    <H>
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <title>{`${title} | ${hostname}`}</title>
      {description && <meta name="description" content={description} />}
      {children}
    </H>
  );
};
export default Head;
